import { render, staticRenderFns } from "./grantRecord.vue?vue&type=template&id=a1218946&scoped=true"
import script from "./grantRecord.vue?vue&type=script&lang=js"
export * from "./grantRecord.vue?vue&type=script&lang=js"
import style0 from "./grantRecord.vue?vue&type=style&index=0&id=a1218946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1218946",
  null
  
)

export default component.exports